"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureMapOverlay = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var CSS = {
    container: 'c-PhotomeasureOverlay',
    orca: 'c-PhotomeasureOverlay__device',
    orcaIcon: 'c-PhotomeasureOverlay__orcaIcon',
    fov: 'c-PhotomeasureOverlay__fov',
    fovSprite: 'c-PhotomeasureOverlay__fovSprite',
    label: 'c-PhotomeasureOverlay__label'
};
var Style = (_a = {},
    _a[CSS.container] = {
        position: 'absolute'
    },
    _a[CSS.orca] = {
        position: 'absolute',
        transform: 'translate3d(-16px, -16px, -1px)',
        width: '32px',
        height: '32px',
        borderRadius: '16px',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4
    },
    _a[CSS.orcaIcon] = {
        width: '32px',
        height: '32px',
        transformOrigin: '50% 50%'
    },
    _a[CSS.fov] = {
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate3d(-75px, -129px, -1px)'
    },
    _a[CSS.fovSprite] = {
        width: '150px',
        height: '129px',
        transformOrigin: '50% 100%'
    },
    _a[CSS.label] = {
        paddingTop: '20px'
    },
    _a);
(0, theme_1.addStyles)(Style);
var PhotomeasureMapOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(PhotomeasureMapOverlay, _super);
    function PhotomeasureMapOverlay(options) {
        var _this = _super.call(this) || this;
        _this.name = 'PhotomeasureMapOverlay';
        _this.overlay = new google.maps.OverlayView();
        _this.capture = options.capture || null;
        _this.overlay.onAdd = function () {
            _this.el = _this.overlay.getPanes().overlayLayer;
            services_1.Services.Render.mount(_this.el, _this, _this.name);
        };
        _this.overlay.onRemove = function () {
            if (_this.el) {
                services_1.Services.Render.mount(_this.el, null, _this.name);
            }
        };
        _this.overlay.draw = _this.onDraw.bind(_this);
        services_1.Services.Map.isReadyPromise
            .then(function () {
            _this.overlay.setMap(services_1.Services.Map.map);
        });
        return _this;
    }
    PhotomeasureMapOverlay.prototype.setCapture = function (capture) {
        this.capture = capture;
        this.onDraw();
    };
    PhotomeasureMapOverlay.prototype.onRemove = function () {
        if (this.el) {
            services_1.Services.Render.mount(this.el, null, this.name);
        }
    };
    PhotomeasureMapOverlay.prototype.onDraw = function () {
        if (this.el) {
            services_1.Services.Render.render(this.el, this.view());
        }
    };
    PhotomeasureMapOverlay.prototype.canSeeFieldOfView = function () {
        return (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_FIELD_OF_VIEW));
    };
    Object.defineProperty(PhotomeasureMapOverlay.prototype, "nodes", {
        get: function () {
            var projection = this.overlay.getProjection();
            if (projection && this.capture && this.capture.device && this.canSeeFieldOfView()) {
                var _a = this.capture.device, latitude = _a.latitude, longitude = _a.longitude;
                var point = projection.fromLatLngToDivPixel(new google.maps.LatLng({
                    lat: latitude,
                    lng: longitude
                }));
                return (0, mithril_1.m)('div', {
                    className: CSS.container,
                    style: {
                        left: "".concat(point.x, "px"),
                        top: "".concat(point.y, "px")
                    }
                }, [
                    (0, mithril_1.m)('div', {
                        className: CSS.fov
                    }, (0, mithril_1.m)('img', {
                        src: (0, theme_1.assetPath)('/images/fov-cone.svg'),
                        className: CSS.fovSprite,
                        style: {
                            transform: "rotate(".concat(this.capture.orientation.bearing, "rad)")
                        }
                    })),
                    (0, mithril_1.m)('div', {
                        className: CSS.orca
                    }, (0, mithril_1.m)('img', {
                        src: (0, theme_1.assetPath)('/images/ike-device.svg'),
                        className: CSS.orcaIcon,
                        style: {
                            transform: "rotate(".concat(this.capture.orientation.bearing, "rad)")
                        }
                    })),
                    (0, mithril_1.m)('div', {
                        className: CSS.label
                    }, core_shared_1.IkeUnit.display(this.capture.distance, services_1.Services.UserSettings.units))
                ]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotomeasureMapOverlay.prototype, "capture", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotomeasureMapOverlay.prototype, "setCapture", null);
    return PhotomeasureMapOverlay;
}(mithril_component_1.IMithrilComponent));
exports.PhotomeasureMapOverlay = PhotomeasureMapOverlay;
//# sourceMappingURL=photomeasure.map.overlay.js.map